import { AppType } from '@environment';

export const STREAMING_INTERSECTION_CONFIG: Record<AppType, { querySelector: string; eventName: string }> = {
  ['widget']: {
    querySelector: 'where-to-watch',
    eventName: 'UsheruSelectViewed'
  },
  ['cdp']: {
    querySelector: '#ush-at-home-wrapper',
    eventName: 'StreamingViewed'
  }
};

export const SHOWTIMES_INTERSECTION_CONFIG: Record<AppType, { querySelector: string; eventName: string }> = {
  ['widget']: {
    querySelector: 'where-to-watch',
    eventName: 'UsheruSelectViewed'
  },
  ['cdp']: {
    querySelector: '#ush-showtimes-widget-wrapper',
    eventName: 'ShowtimesViewed'
  }
};
